module.exports = __webpack_public_path__ + "static/media/user-image-restaurant.28120736.svg";